import { gql } from '@apollo/client'
import React from 'react'

import { triggersClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useRoutineState = () => React.useContext(Context)
export const useRoutine = () => useRoutineState()?.trigger

const QUERY = gql`
  query Trigger($id: ID) {
    trigger(id: $id) {
      id
      action
      conditions
      entity
      event
      type
      payload
      readOnly
      insertedAt
      name
      folderId
      frequency
      frequencyIndex
      until
      initialDate
      folder {
        id
        name
      }
    }
  }
`

const RoutineLoader = ({ children }) => {
  const { id, cloneFromId } = useModalData()

  const { data, ...state } = useQuery(QUERY, {
    skip: !id && !cloneFromId,
    variables: { id: id || cloneFromId },
    client: triggersClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default RoutineLoader
